import { Alert, Spin } from 'antd';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import React, { Component } from 'react';

import 'antd/dist/antd.css';

import { login } from '../../actions/Authentication';

class Welcome extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            error: false,
            errorMessage: ''
        }
    }

    submitForm(values) {
        const { username, password } = values;

        this.setState({ isLoading: true });
        this.props.login(username, password, (success, errorMessage) => {
            if (errorMessage) {
                this.setState({ isLoading: false, error: true, errorMessage: errorMessage });
            } else {
                this.setState({ isLoading: false, error: false, errorMessage: '' });
                this.props.history.push('/');
            }
        });
    }

    renderField(field) {
        const { meta: { touched, error }, input, placeholder, label, type, name, iconName } = field;
        const className = `form-group input-txt ${touched && error ? 'input-left-icon-error' : ''}`;

        return (
            <div className={className}>
                <label htmlFor="username">{label}</label>
                <div className="input-group">
                    <div className="input-group-addon">
                        <img src={iconName} alt="" />
                    </div>
                    <input
                        type={type}
                        className="form-control"
                        id={name}
                        name={name}
                        placeholder={placeholder}
                        {...input}
                    />
                </div>
                <span className="error-message">{touched ? error : ''}</span>
            </div>

            // <div className="field">
            //     <label>{label}</label>
            //     <div className="form-group input-txt">
            //         <div className="ui label">
            //             <img src={`/images/${iconName}`} alt="" />
            //         </div>
            //         <input name={name} type={type} placeholder={placeholder} {...input} autoComplete="none" />
            //     </div>
            // </div>
        );
    }

    renderError() {
        if (this.state.error) {
            return (
                <Alert
                    message={this.state.errorMessage}
                    type="error"
                />
            );
        }
    }

    render() {
        const { handleSubmit } = this.props;

        return (
            <div className="container-welcome">
                <Spin spinning={this.state.isLoading} size="large">
                <h1>Welcome</h1>
                <p>Please enter Username and Password to login to the system.</p>
                    <form onSubmit={handleSubmit(this.submitForm.bind(this))}>
                        <Field
                            name="username"
                            label="Username:"
                            placeholder="Username"
                            id="username"
                            type="text"
                            iconName="/resources/img/ic-username.png"
                            component={this.renderField}
                        />
                        <Field
                            name="password"
                            label="Password:"
                            placeholder="Password"
                            id="password"
                            type="password"
                            iconName="/resources/img/ic-password.png"
                            component={this.renderField}
                        />
                        {this.renderError()}
                        <button className="btn button green-btn" type="submit">
                            Login
                    </button>
                    </form>
                </Spin>
            </div>
        )
    }
}

const validate = (values) => {
    let errors = {};
    if (!values.username) {
        errors.username = 'Please enter username';
    }
    if (!values.password) {
        errors.password = 'Please enter password';
    }
    return errors;
}

Welcome = reduxForm({
    validate,
    form: 'AdminWelcomeForm'
})(Welcome);

Welcome = connect(null, { login })(Welcome);

export default Welcome;


// WEBPACK FOOTER //
// ./src/views/welcome/index.js